import { makeStyles } from 'e100-react-components';

import { DECK_OVERLAY_ID } from 'entities/map';

const useGlobalStyles = makeStyles(() => ({
  '@global': {
    '#map': {
      cursor: 'grab',
      '& > div': {
        cursor: 'unset !important'
      },
    },
    [`#${DECK_OVERLAY_ID}`]: {
      top: 0,
      left: 0,
    }
  }
}));

export default useGlobalStyles;
